<template lang="pug">
  div.body.body-table.garbage-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent="letSearch")
              // input(type="search" placeholder="" v-model="searchModel")
            div.parameters
              e-year-selector(year="year")
            div.actions-panel
              e-button-add(@click="addNewRowToGarbageTable")
              // button(v-if="role!=='guest'" type="button" @click="addNewRowToGarbageTable").actions-panel__button.btn-add.green

      div(v-if="operationType === 'output'")
        e-table-editable(
        ref="output"
        :attributes="garbageOutputAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :tableInOnlineMode="tableInOnlineMode"
        :defaultColumnWidth="150"
        :summaryColumns="summaryColumns"
        )
      div(v-else-if="operationType === 'waste-generation'")
        e-table-editable(
        ref="wasteGeneration"
        :attributes="wasteGenerationAttr"
        :dataUrl="wasteGenerationDataUrl"
        :postUrl="wasteGenerationPostUrl"
        :patchUrl="wasteGenerationPatchUrl"
        :deleteUrl="wasteGenerationDeleteUrl"
        :tableInOnlineMode="tableInOnlineMode"
        :defaultColumnWidth="150"
        :summaryColumns="summaryColumns"
        )
      div(v-else-if="operationType === 'waste-generation'")
        e-table-editable(
        ref="wasteGeneration"
        :attributes="wasteGenerationAttr"
        :dataUrl="wasteGenerationDataUrl"
        :postUrl="wasteGenerationPostUrl"
        :patchUrl="wasteGenerationPatchUrl"
        :deleteUrl="wasteGenerationDeleteUrl"
        :tableInOnlineMode="tableInOnlineMode"
        :defaultColumnWidth="150"
        :summaryColumns="summaryColumns"
        )
</template>

<script>
  import {tko, atu, cadastr} from '../../../../api/api-endpoints.js'
  import {atuOffline} from '../../../../api/api-offline-endpoints.js'
  import year from '../../../../utils/year.js'

  import {ACTIONS_FOR_ATU} from "../../../../config/config"

  export default {
    name: 'garbage-threads-table',
    props: {
      id: null
    },
    data () {
      return {
        operationType: null,
        year: year.getCurrentYear(),
        search: '',
        searchModel: '',
        sort: null,
        paginationQuery: null
      }
    },
    computed: {
      summaryColumns () {
        return ['total', 'total_cubic']
      },
      selectListOptions () {
        return [
          {
            id: 'output',
            name: 'Распределение отходов'
          },
          {
            id: 'waste-generation',
            name: 'Образование отходов'
          }
        ]
      },
      tableInOnlineMode () {
        return this.$route.params.id
      },
      garbageOutputAttr () {
        return {
          fkko: {
            label: 'ФККО',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            },
            width: 200
          },
          danger: {
            label: 'Класс опасности',
            placeholder: ' ',
            //required: true,
            disabled: true
          },
          tko_object: {
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название объекта',
            label: 'Объект',
            suggestion: {
              options: [],
              onSelect: this.onSelectTKO,
              suggestionEndpoint: this.suggestionTKOEndpoint,
              transformSuggestions: this.transformTKOSuggestions
            }
          },
          address: {
            label: 'Адрес',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          tko_object_type: {
            label: 'Категория объекта',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          tko_action_id: {
            label: "Назначение",
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            required: true,
            select: {
              options: this.optionsAction
            },
            transform: function (model) {
              if (model.tko_action_id) {
                for (let key in ACTIONS_FOR_ATU) {
                  if (ACTIONS_FOR_ATU[key].tko_action_id === model.tko_action_id) {
                    return ACTIONS_FOR_ATU[key].label
                  }
                }
              }
              return ''
            }
          },
          total: {
            label: 'Кол-во отходов, тонн',
            required: true
          },
          total_cubic: {
            label: 'Кол-во отходов, м³',
            required: false
          }
        }
      },
      optionsAction () {
        let tmp = []
        for (let name in ACTIONS_FOR_ATU) {
          let v = ACTIONS_FOR_ATU[name]
          tmp.push({
            id: v.tko_action_id,
            name: v.label
          })
        }

        return tmp
      },
      garbageDataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              sourceId: this.id,
              year: this.year,
              type: this.operationType,
              garbage_type: 'default'
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }
          if (this.sort) {
            routeQuery.query.sort = this.sort
          }
          if (this.paginationQuery) {
            routeQuery.query = Object.assign(routeQuery.query, this.paginationQuery)
          }

          return atu.atuObjectOperations(routeQuery)
        }
        // if new record, offline save
        return atuOffline.atuObjectOperationTable(this.$route.name, this.year, this.operationType)
      },
      wasteGenerationAttr () {
        return {
          fkko: {
            label: 'ФККО',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            },
            width: 200
          },
          danger: {
            label: 'Класс опасности',
            placeholder: ' ',
            //required: true,
            disabled: true
          },
          total: {
            label: 'Кол-во отходов, тонн',
            required: true
          },
          total_cubic: {
            label: 'Кол-во отходов, м³',
            required: false
          }
        }
      },
      wasteGenerationDataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              sourceId: this.id,
              year: this.year,
              type: this.operationType,
              garbage_type: 'default'
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }
          if (this.sort) {
            routeQuery.query.sort = this.sort
          }
          if (this.paginationQuery) {
            routeQuery.query = Object.assign(routeQuery.query, this.paginationQuery)
          }

          return atu.atuObjectOperations(routeQuery)
        }
        // if new record, offline save
        return atuOffline.atuObjectOperationTable(this.$route.name, this.year, this.operationType)
      },
    },
    methods: {
      // выбор объекта
      onSelectTKO (ctx, $event, model) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.tko_object_id = copy.id
          model.tko_object = this.$options.filters.stripHtml(copy.name)
          model.address = copy.address
          model.tko_object_type = copy.actions
        } else {
          model.tko_object_id = ''
          model.tko_object = ''
          model.address = ''
          model.tko_object_type = ''
        }
      },
      suggestionTKOEndpoint (ctx, q) {
        return tko.objects({query: {q: q, 'per-page': 50}})
      },
      transformTKOSuggestions (ctx, response) {
        let data = response.data
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].id + ' ' + data[i].name,
            id: data[i].id,
            address: data[i].address,
            actions: (
              Array.isArray(data[i].actions)
                ? data[i].actions.map(v => v.name).join(', ')
                : ''
            )
          })
        }
        return options
      },
      // фкко
      onSelect (ctx, $event, model) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.fkko_id = copy.id
          model.fkko = copy.fkkoName
          model.danger = copy.danger
        } else {
          model.fkko_id = ''
          model.fkko = ''
          model.danger = ''
        }
      },
      suggestionEndpoint (ctx, q) {
        return cadastr.fkko({query: {q: q, 'per-page': 50}})
      },
      transformSuggestions (ctx, response) {
        let data = response.data
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].code + ' ' + data[i].name,
            fkkoName: data[i].name,
            id: data[i].id,
            code: data[i].code,
            danger: data[i].danger
          })
        }
        return options
      },
      garbagePostUrl () {
        return atu.atuObjectOperationPost({
          query: {
            sourceId: this.id,
            year: this.year,
            type: this.operationType
          }
        })
      },
      garbagePatchUrl (context, model) {
        return atu.atuObjectOperationPatch({
          query: {
            sourceId: model.id,
            year: model.year,
            type: this.operationType
          }
        })
      },
      garbageDeleteUrl (context, model) {
        return atu.atuObjectOperationDelete({
          query: {
            sourceId: model.id,
            year: this.year,
            type: this.operationType
          }
        })
      },
      wasteGenerationPostUrl () {
        return atu.atuObjectOperationPost({
          query: {
            sourceId: this.id,
            year: this.year,
            type: this.operationType
          }
        })
      },
      wasteGenerationPatchUrl (context, model) {
        return atu.atuObjectOperationPatch({
          query: {
            sourceId: model.id,
            year: model.year,
            type: this.operationType
          }
        })
      },
      wasteGenerationDeleteUrl (context, model) {
        return atu.atuObjectOperationDelete({
          query: {
            sourceId: model.id,
            year: this.year,
            type: this.operationType
          }
        })
      },
      addNewRowToGarbageTable () {
        if (this.operationType === 'output') {
          const Model = () => {
            return {
              tko_object: '',
              tko_object_id: '',
              danger: '',
              total: '',
              total_cubic: '',
              address: '',
              tko_object_type: '',
              tko_action_id: '',
              // can be used for turn year select
              _operationType: JSON.parse(JSON.stringify(this.operationType)),
              _year: JSON.parse(JSON.stringify(this.year))
            }
          }
          this.$refs.output.createRow(new Model())
        } else if (this.operationType === 'waste-generation') {
          const Model = () => {
            return {
              danger: '',
              total: '',
              total_cubic: '',
              // can be used for turn year select
              _operationType: JSON.parse(JSON.stringify(this.operationType)),
              _year: JSON.parse(JSON.stringify(this.year))
            }
          }
          this.$refs.wasteGeneration.createRow(new Model())
        }
      },
    }
  }
</script>
